import React from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'

interface BoundedImageProps {
  className?: string
  alt?: string
  path: string
  sizes?: string
  imageClassName?: string
  width?: number
  height?: number
}

export const BoundedImage: React.FC<BoundedImageProps> = ({
  className,
  alt,
  path,
  sizes,
  imageClassName,
  width,
  height,
}) => {
  return (
    <div className={classNames('relative max-w-full overflow-hidden', className)}>
      <Image
        alt={alt ?? ''}
        src={getCloudinaryImageUrl({
          path: path,
          transforms: 'e_trim,c_fit,q_auto:good,f_auto',
        })}
        width={width ?? 300}
        height={height ?? 300}
        sizes={classNames('(max-width: 600px) 358px, (max-width: 1024px) 600px, 600px', sizes)}
        className={classNames(
          'h-auto max-h-[64px] w-auto max-w-full object-contain md:max-h-[80px] lg:max-h-[104px] lg:max-w-[600px] shortDesktop:max-h-[80px]',
          imageClassName,
        )}
      />
    </div>
  )
}
